/**
 * Blog Module Constants
 */
export const SUPPORTED_LANGUAGES = ['tr', 'en', 'de', 'fr', 'es', 'ar'];

export const POST_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived'
};

export const POST_STATUS_LABELS = {
  [POST_STATUSES.DRAFT]: 'Taslak',
  [POST_STATUSES.PUBLISHED]: 'Yayınlandı',
  [POST_STATUSES.ARCHIVED]: 'Arşivlendi'
};

